import React from "react";

const Brand = () => {
  return (
    <section className="section bg-light text-center">
      <h2 className="mb-4">Trusted by</h2>
      <div className="logo-container d-flex justify-content-center flex-wrap gap-5">
        <img
          src="assets/images/logo-1.png"
          alt="Logo 1"
          className="trusted-logo"
        />
        <img
          src="assets/images/logo-2.png"
          alt="Logo 2"
          className="trusted-logo"
        />
        <img
          src="assets/images/logo-3.png"
          alt="Logo 3"
          className="trusted-logo"
        />
        <img
          src="assets/images/logo-4.png"
          alt="Logo 4"
          className="trusted-logo"
        />
        <img
          src="assets/images/logo-5.png"
          alt="Logo 5"
          className="trusted-logo"
        />
      </div>
      <div class="container">
        <p className="mx-auto text-center mt-5 text-danger fs-5">
          Trusted by <strong>1200+</strong> store owners worldwide. No hidden
          fees. Secure payments.
        </p>
      </div>
    </section>
  );
};

export default Brand;
